<script lang="ts">
    import { toggleSwitchIcon, toggleSwitchOffIcon } from './icons'
    import Icon from './Icon.svelte'

    interface Props {
        state: boolean
        disabled?: boolean
        ariaDescribedby?: string | null
        ariaLabelledby?: string | null
        toggle: () => void
    }

    let { state, disabled = false, ariaDescribedby = null, ariaLabelledby = null, toggle }: Props = $props()
</script>

<button
    class="conb-toggle conb-state-{state ? 'on' : 'off'}"
    {disabled}
    role="switch"
    aria-checked={state}
    aria-disabled={disabled}
    aria-labelledby={ariaLabelledby}
    aria-describedby={ariaDescribedby}
    onclick={() => {
        if (!disabled) toggle()
    }}
>
    <!-- <iconify-icon icon={state ? toggleSwitchIcon : toggleSwitchOffIcon} aria-hidden="true" /> -->
    <Icon icon={state ? toggleSwitchIcon : toggleSwitchOffIcon} aria-hidden="true" />
</button>
